import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import Delete from 'material-ui/svg-icons/action/delete';
import DropZone from 'react-dropzone';
import Folder from 'material-ui/svg-icons/file/folder';
import {TextInput} from '../../shared/components';
import toastr from 'toastr';
import {withRouter} from 'react-router';
import React, {Component, PropTypes} from 'react';

class FileUploader extends Component {
  constructor(props, context) {
    super(props, context);
    autoBind(this);
  }

  assignDropZoneReference(node) {
    this.dropzoneNodeRef = node;
  }

  handleOpenDropZone() {
    if (!this.dropzoneNodeRef) return;
    this.dropzoneNodeRef.open();
  }

  handleFileSelectWrapper(files) {
    const {onFileSelect, fileIndex} = this.props;
    onFileSelect(files, fileIndex);
  }

  handleFileResetWrapper() {
    const {onFileReset, fileIndex} = this.props;
    onFileReset(fileIndex);
  }

  handleRejectedDrop() {
    toastr.error('Error', 'Unable to process selected file', {timeout: 10000, allowHtml: true});
  }

  render() {
    const {accept, id, className, fileName, labelText} = this.props;
    const defaultClassName = 'file-uploader';
    const combinedClassName = className ? `${className} ${defaultClassName}` : defaultClassName;

    return (
      <div className={combinedClassName}>
        <div className="file-uploader-name-input">
          <TextInput className="file-uploader-text-input"
            id={id}
            value={fileName}
            floatingLabelText={labelText}
            onClick={this.handleOpenDropZone}
            readOnly />
        </div>
        <div className="icon-container">
          <DropZone
            className="dropzone-container"
            accept={accept}
            ref={this.assignDropZoneReference}
            onDropAccepted={this.handleFileSelectWrapper}
            onDropRejected={this.handleRejectedDrop}>
            <Folder className="icon" />
          </DropZone>
          <Delete className="icon" onClick={this.handleFileResetWrapper} />
        </div>
      </div>
    );
  }
}

FileUploader.propTypes = {
  accept: PropTypes.string.isRequired,
  className: PropTypes.string,
  fileIndex: PropTypes.number,
  fileName: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  onFileReset: PropTypes.func.isRequired,
  onFileSelect: PropTypes.func.isRequired,
};

export default withRouter(connect()(FileUploader));



// WEBPACK FOOTER //
// ./app/features/shared/components/FileUploader.js